import {useQuery} from "react-query";
import {useParams} from "react-router-dom";
import api from "../services/api";

const fetchModule = (timing, module) => {
  return api.get(`/timings/${timing}/modules/${module}`).then(result => result?.data?.data);
}

const useFetchModule = (module, config) => {
  const { timing } = useParams();

  return useQuery(['modules', module], () => fetchModule(timing, module), config);
};

export default useFetchModule;
